<template>
  <div>
    <div class="row mt-4">
      <div class="col-12">
        <div class="d-flex h-100">
          <div class="justify-content-center align-self-center w-100">
            <MenuItem style="margin-top:-100px;"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import MenuItem from "@/components/Menu.vue";
import MenuItem from "@/components/Menu.vue";

export default {
  name: "HeroItem",
  components:{
    MenuItem
    //MenuItem,
  },
};
</script>

<style>
</style>